import React from 'react';
import { Grid } from '@material-ui/core';
import { Colors, Text } from 'library';
import { CommentModel } from '../NewsfeedModels';
import { track } from 'shared/Tracking';
import { useHistory } from 'react-router-dom';
import { calculatePostAdded } from '../dateUtils';
import ExistingCommentActionBar from '../ActionBar/ExistingCommentActionBar';
import CommentAttachments from '../Attachments/CommentAttachments';
import UserPostPicture from '../UserPostPicture';
const Comment = ({ comment, refresh }: { comment: CommentModel; refresh: () => void }) => {
    const history = useHistory();

    const navigateToUserProfile = () => {
        if (comment.user.role === 'PROVIDER') {
            track('Posts: Navigate To User Profile', { comment });
            history.push(`/provider/${comment.user.id}`);
        }
    };

    return (
        <>
            <Grid
                container
                direction="row"
                style={{ cursor: 'pointer', display: 'flex', flexWrap: 'nowrap', paddingLeft: 10, paddingRight: 10 }}
                onClick={navigateToUserProfile}
            >
                <UserPostPicture
                    profileImage={comment.user.profile_picture ? comment.user.profile_picture.image : ''}
                />
                <Grid
                    container
                    item
                    direction="column"
                    justify="center"
                    style={{
                        backgroundColor: Colors.lightGrey,
                        borderRadius: 15,
                        padding: 10,
                        marginBottom: 10,
                        flexShrink: 1,
                    }}
                >
                    <Text variant="body2" bold textStyle={{ lineHeight: '8pt' }}>
                        {`${comment.user.first_name} ${
                            comment.user.role === 'NONE' ? '' : comment.user.last_name_initial
                        }`}
                    </Text>
                    <Text variant="deprecatedCaption" textStyle={{ lineHeight: '6pt' }}>
                        {comment.last_updated ? calculatePostAdded(comment.last_updated) : ''}
                    </Text>
                    <Grid direction="row">
                        {comment.comment.split(' ').map((word) => (
                            <div style={{ flexDirection: 'row', display: 'inline-flex' }}>
                                {word[0] === '@' && word.length > 1 && word.includes('_') ? (
                                    <Text variant="body1" color={Colors.turquoise} bold>
                                        {word.replace('_', ' ')}
                                    </Text>
                                ) : (
                                    <Text
                                        textStyle={{ wordWrap: 'break-word', wordBreak: 'break-all' }}
                                        variant="body1"
                                    >
                                        {word}
                                    </Text>
                                )}
                                &nbsp;
                            </div>
                        ))}
                    </Grid>
                    <Grid>
                        {comment.attachments ? (
                            <Grid style={{ marginTop: 20 }}>
                                <CommentAttachments items={comment.attachments} />
                            </Grid>
                        ) : null}
                    </Grid>
                </Grid>
            </Grid>
            <ExistingCommentActionBar comment={comment} refresh={refresh} />
        </>
    );
};

export default Comment;
